import { useEffect, useRef, useState } from "react";
import { useApi } from "../../hooks/useApi";


const ActiveUsers = ({}) => {
    const [loading, setLoading] = useState(true);
    const [componentValid, setComponentValid] = useState(true);
    const [activeUserCount, setActiveUserCount] = useState(0);
    const [activeUsers, setActiveUsers] = useState([]);
    const [showAU, setShowAU] = useState(false);
    const [userSessionCount, setUserSessionCount] = useState(0);
    const [userSessions, setUserSessions] = useState([]);
    const [showUS, setShowUS] = useState(false);
    
    const activeFetching = useRef(null);

    const {fetchGet} = useApi();

    
    const fetchActiveUsers = () => {
        fetchGet("/routes/api/stats/users/all")
        .then(data => {
            if(data?.type === "error") {
                setComponentValid(false);
            }
            
            setActiveUserCount(data?.userCount || 0);
            setActiveUsers(data?.activeUserUsers|| []);
            setUserSessionCount(data?.userSessionCount || 0);
            setUserSessions(data?.userSessionUsers || []);
            setLoading(false);    

            setTimeout(() => {
                activeFetching.current = fetchActiveUsers();
            }, (1000*60*5));
        })
        .catch(err => {
            console.log(err);
            setComponentValid(false);
            setLoading(false);
            setTimeout(() => {
                activeFetching.current = fetchActiveUsers();
            }, (1000*60*5));
        })
    };

    useEffect(() => {
        if(activeFetching.current) {
            return;
        }

        activeFetching.current = fetchActiveUsers();
    }, []);

    return (
        <>
            {   loading ?
                <>
                    ---
                </>
                :
                <>
                    <div className={"textAlignCenter"} style={{}}>
                        {   componentValid ?
                            <>
                                {activeUserCount}
                                {" "+"Active Users"}
                                <br />
                                <button type="button" onClick={() => setShowAU(prev => !prev)}>{showAU ? "Hide Users" : "Show Users"}</button>
                                <br />
                                {showAU && activeUsers.join(",")}
                            </>
                            :  
                            <>
                                ---
                            </>
                        }
                    </div>
                </>
            }

            <br />
            {   loading ?
                <>
                    ---
                </>
                :
                <>
                    <div className={"textAlignCenter"}>
                        {   componentValid ?
                            <>
                                {userSessionCount}
                                {" "+"Users Sessions"}
                                <br />
                                <button type="button" onClick={() => setShowUS(prev => !prev)}>{showUS ? "Hide Users" : "Show Users"}</button>
                                <br />
                                {showUS && userSessions.join(", ")}
                            </>
                            :  
                            <>
                                ---
                            </>
                        }
                    </div>
                </>
            }
        </>
    );
};

export default ActiveUsers